import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';


import { ConfigServerService, CustomHttp } from '../../../../../core';
import { IntegrationNotaFiscal } from '../integration-nota-fiscal';

@Injectable({
    providedIn: 'root'
})
export class IntegrationNotaFiscalHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApiIntegration()}/notafiscal`;
    }

    /** Executa a integração de leitura das notas fiscals com os sistemas ERP's */
    execReadIntegration(entity: IntegrationNotaFiscal): Observable<string> {
        // Params
        let params = new HttpParams();
        if (entity) {
            params = entity.createParams(params);
        }

        return this.customHttp.post<string>(this.pathApi, null, {params, responseType : 'text'});
    }

    /** Executa a integração de leitura individual dos dados da nota fiscal informado no ERP */
    execReadIndividualIntegration(id: number): Observable<string> {
        return this.customHttp.post<string>(`${this.pathApi}/individual/${id}`, null, {responseType: 'text'});
    }
}
